module.exports = __webpack_public_path__ + "img/empty_desktop.6c53f928.svg";